import React from 'react';
import { useTranslation } from 'react-i18next';
import { DollarSignIcon, ShieldIcon, PackageIcon, UsersIcon } from 'lucide-react';
import { SyndicateExample } from './SyndicateExample';
export function SyndicateAuctions() {
  const {
    t
  } = useTranslation();
  return <section id="auctions" className="bg-gray-50 dark:bg-black text-gray-900 dark:text-white py-20" data-id="element-873">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-874">
        <div className="text-center mb-12" data-id="element-875">
          <div className="inline-block px-4 py-1 bg-blue-100 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green rounded-full text-sm font-medium mb-4" data-id="element-876">
            {t('syndicateAuctions.badge')}
          </div>
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white" data-id="element-877">
            {t('syndicateAuctions.title.prefix')}{' '}
            <span className="bg-gradient-to-r from-blue-600 to-blue-400 dark:from-brand-green dark:to-brand-green/60 bg-clip-text text-transparent" data-id="element-878">
              {t('syndicateAuctions.title.highlight')}
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mt-4 max-w-2xl mx-auto" data-id="element-879">
            {t('syndicateAuctions.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start" data-id="element-880">
          <div data-id="element-881">
            <div className="mb-8" data-id="element-882">
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-883">
                {t('syndicateAuctions.whatIs.title')}{' '}
                <span className="text-blue-600 dark:text-brand-green" data-id="element-884">
                  {t('syndicateAuctions.whatIs.highlight')}
                </span>
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mt-4" data-id="element-885">
                {t('syndicateAuctions.whatIs.description')}
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-886">
              {t('syndicateAuctions.benefits', {
              returnObjects: true
            }).map((benefit, index) => <div key={index} className="border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-887">
                  <div className="flex items-center mb-4" data-id="element-888">
                    <div className="h-10 w-10 flex items-center justify-center rounded-full bg-blue-100 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green mr-3" data-id="element-889">
                      {index === 0 ? <DollarSignIcon className="h-5 w-5" data-id="element-890" /> : index === 1 ? <PackageIcon className="h-5 w-5" data-id="element-891" /> : index === 2 ? <ShieldIcon className="h-5 w-5" data-id="element-892" /> : <PackageIcon className="h-5 w-5" data-id="element-893" />}
                    </div>
                    <h4 className="font-semibold text-gray-900 dark:text-white" data-id="element-894">
                      {benefit.title}
                    </h4>
                  </div>
                  <p className="text-gray-600 dark:text-gray-400 text-sm" data-id="element-895">
                    {benefit.description}
                  </p>
                </div>)}
            </div>
          </div>
          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-8 shadow-md" data-id="element-896">
            <h3 className="text-xl font-bold text-gray-900 dark:text-white flex items-center mb-6" data-id="element-897">
              <div className="h-10 w-10 flex items-center justify-center rounded-full bg-blue-100 dark:bg-brand-green/10 mr-3" data-id="element-898">
                <UsersIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-899" />
              </div>
              {t('syndicateAuctions.structure.title')}
            </h3>
            <div className="space-y-8" data-id="element-900">
              {t('syndicateAuctions.structure.roles', {
              returnObjects: true
            }).map((role, index) => <div key={index} className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg" data-id="element-901">
                  <h4 className="font-semibold text-blue-600 dark:text-brand-green mb-2" data-id="element-902">
                    {role.title}
                  </h4>
                  <p className="text-gray-600 dark:text-gray-400" data-id="element-903">
                    {role.description}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
        <SyndicateExample data-id="element-904" />
        <div className="mt-12 text-center" data-id="element-905">
          <a href="#contact-form" className="inline-flex items-center px-8 py-3 bg-blue-600 dark:bg-brand-green text-white dark:text-black rounded-full hover:bg-blue-700 dark:hover:bg-brand-green/90 transition-all transform hover:scale-105" data-id="element-906">
            {t('syndicateAuctions.cta', 'Join a Syndicate Today')}
          </a>
        </div>
      </div>
    </section>;
}